const SESSION_TITLE_PREFIX = /^sherlog\s*(?::|-|\u2013|\u2014)\s*/i;

/** Remove internal product branding before showing a session title in the web UI. */
export function formatSessionTitle(title: string): string {
  return title.replace(SESSION_TITLE_PREFIX, "").trim();
}
